import * as types from '_/vuex/mutation-types';

import { api } from '_/services/api';

import { errorCommit } from '_/vuex/actions/commonActions';

export default {
    /**
     * Clears the advanced search filters
     */
    clearAdvancedSearchFilters({ commit }) {
        commit(types.CLEAR_ADVANCED_SEARCH_FILTER);
    },

    /**
     * Empties the entries state property
     */
    emptyEntries({ commit }) {
        commit(types.UPDATE_FILTERED_ENTRIES, { entries: [] });
        commit(types.UPDATE_CURRENT_PAGE_NUMBER, { value: 1 });
    },

    /**
     * Filters articles with their comments via the custom API endpoint
     */
    filterModuleEntries({ commit }, { payload } = {}) {
        return api
            .post(
                '/public-api/list-comments',
                payload,
                {},
                { Depth: '1' }
            )
            .then((response) => {
                if (response.data.body.pagination !== 'undefined') {
                    const entries = response.data.body.entries;
                    commit(types.UPDATE_FILTERED_ENTRIES, { entries });

                    const pagination = response.data.body.pagination;
                    commit(types.LOAD_DYNAMIC_MODULE_ENTRIES_PAGINATION, { pagination });
                }
            })
            .catch((response) => {
                return errorCommit({ commit }, response, 'ADMIN');
            });
    },

    /**
     * Navigates to the specified result page
     */
    navigateToPage({ commit, dispatch, state }, { value }) {
        commit(types.UPDATE_CURRENT_PAGE_NUMBER, { value });
        return dispatch('filterModuleEntries', { payload: state.payload });
    },

    /**
     * Submits the PUT request to update a comment entry
     */
    submitCommentEntry({ commit, dispatch, state }, { id, payload }) {
        return api['put'](`comments/${id}`, payload, {}, { Depth: '3' })
            .then((response) => {
                return Promise.resolve(response.data.body);
            })
            .catch((response) => {
                errorCommit({ commit }, response, 'ADMIN');
                return Promise.reject(response);
            });
    },

    /**
     * Updates the filter value
     */
    updateFilterValue({ commit }, { fieldName, value }) {
        commit(types.UPDATE_FILTER_VALUE, { fieldName, value });
    },
};
